// The map types (base layers), ordered like the 3D viewer's map-type control. maxNativeZoom caps the highest tile-request zoom per
// provider. Beyond it, Leaflet upsamples the deepest available tile (pixelated
// but visible) instead of requesting non-existent tiles and showing a blank
// background.
export const TILE_LAYERS = [
  {
    id: 'street',
    label: 'Street',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxNativeZoom: 19,
  },
  {
    id: 'terrain',
    label: 'Terrain',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution:
      '&copy; <a href="https://opentopomap.org">OpenTopoMap</a>, &copy; OpenStreetMap contributors',
    maxNativeZoom: 17,
  },
  {
    id: 'satellite',
    label: 'Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '&copy; <a href="https://www.esri.com/">Esri</a>, Maxar, Earthstar Geographics',
    maxNativeZoom: 18,
  },
] as const;

export type TileLayerId = (typeof TILE_LAYERS)[number]['id'];

/** The base layer with this id; an unknown id (say, a stale saved choice) gets Satellite. */
export function tileLayerFor(id: string): (typeof TILE_LAYERS)[number] {
  return TILE_LAYERS.find((l) => l.id === id) ?? TILE_LAYERS[2];
}
